export default __webpack_public_path__ + "static/media/screen6.e191e321.jpg";